module.exports = "/components/components/shiftAppearanceComponent-68345a.html";